import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import {
  PageTitle,
  RadioButton,
  SelectAccordion
} from 'components/common/Elements/Elements';
import { createFilterFeatures } from '../../helpers/helpers';

import classes from './FeaturesAdoptionHeader.module.scss';

const FeaturesAdoptionHeader = ({ input, radio, fa }) => {
  const { t } = useTranslation(['activity']);
  const units = [t('activity:units.OR'), t('activity:units.AND')];

  return (
    <div className={classes.box}>
      <PageTitle
        title={t('activity:features.FEATURES_ADOPTION')}
        className={classes.title}
      />
      <div className={classes.radio}>
        <RadioButton
          handleUnit={radio.onChange}
          unit={radio.value}
          units={units}
          name={t('activity:units.OR_END')}
          classLabel={classes.radio_label}
        />
      </div>
      <label className={classes.fa}>
        <span className={classes.visually_hidden}>
          {t('activity:filters.COMPANY_FEATURE')}
        </span>
        <SelectAccordion
          options={createFilterFeatures(fa, t)}
          input={input}
          limit={10}
        />
      </label>
    </div>
  );
};

FeaturesAdoptionHeader.propTypes = {
  fa: PropTypes.arrayOf(PropTypes.object),
  input: PropTypes.shape({
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired
  }),
  radio: PropTypes.shape({
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
  })
};

export default FeaturesAdoptionHeader;
